// 01.4 · Heure et date dans le fuseau de l'établissement actif (jamais celui du navigateur ni du serveur).
let TZ;
export const setTenantTimezone = (tz) => { TZ = tz && tz !== 'auto' ? tz : undefined; };
export const tenantTimezone = () => TZ;
const parts = (d = new Date()) => {
  const f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', weekday: 'short' });
  const o = Object.fromEntries(f.formatToParts(d).filter((p) => p.type !== 'literal').map((p) => [p.type, p.value]));
  return { y: Number(o.year), m: Number(o.month), d: Number(o.day), h: Number(o.hour) % 24, min: Number(o.minute), wd: o.weekday };
};
export const tenantParts = parts;
export const tenantHour = (d) => parts(d).h;
/** « HH:MM » dans le fuseau de l'établissement. */
export const fmtTime = (d = new Date()) => { const p = parts(d); return `${String(p.h).padStart(2, '0')}:${String(p.min).padStart(2, '0')}`; };
/** « AAAA-MM-JJ » (date civile) dans le fuseau de l'établissement. */
export const tenantTodayIso = (d = new Date()) => { const p = parts(d); return `${p.y}-${String(p.m).padStart(2, '0')}-${String(p.d).padStart(2, '0')}`; };
export const fmtDateLong = (d = new Date(), opts = { weekday: 'long', day: 'numeric', month: 'long' }) => d.toLocaleDateString('fr-FR', { ...opts, timeZone: TZ });
